<template>
  <div class="custom-company-theme-page" :style="customStyle">
    <div class="header">
      <div class="page-title">{{ $t(`${i18nPrefix}.label.theme`) }}</div>
      <el-switch v-model="isActive"></el-switch>
    </div>
    <el-divider></el-divider>
    <div class="setting-container">
      <div v-for="(item, key) in setting" class="setting-item" :key="key">
        <div class="title">
          <span class="label">{{ item.title }}</span>
        </div>
        <SettingContentEditor v-model="data[key]" ref="settingContentEditor" :setting="item.items" :settingType="key" :isDisabled="!isActive">
          <template #footerContent="{ data }">
            <div class="list-setting">
              <draggable
                v-for="(contentList, index) in data"
                tag="div"
                class="list-group"
                handle=".drag-btn"
                filter=".is-disabled"
                group="footer-content-list"
                :list="contentList"
                :key="index"
                @change="handleContentChange($event, data, index)"
              >
                <div v-for="(item, contentIndex) in contentList" class="item" :key="contentIndex">
                  <div class="container-wrapper">
                    <div class="drag-btn" :class="!isActive && 'is-disabled'">
                      <i class="iconfont iconMore"></i>
                    </div>
                    <div class="content">
                      <el-input v-model="item.label" :disabled="!isActive" :placeholder=" $t(`${i18nPrefix}.label.name`)"></el-input>
                    </div>
                    <div class="content">
                      <el-input class="link-input" v-model="item.link" :disabled="!isActive" :placeholder="$t(`${i18nPrefix}.label.link`)"></el-input>
                    </div>
                    <div class="btn-group">
                      <i class="delete-btn iconfont iconRemove" :class="!isActive && 'is-disabled'" @click="handleDeleteContent(contentList, contentIndex, data, index)"></i>
                      <i class="add-btn iconfont iconAdd1"  :class="!isActive && 'is-disabled'"  @click="handleAddContent(contentList)"></i>
                    </div>
                  </div>
                </div>
                <el-divider v-if="index !== data.length - 1"></el-divider>
              </draggable>
              <div>
                <el-button class="add-new-line-btn" size="small" type="primary" :disabled="!isActive" @click="handleAddNewContentList(data)">{{ $t(`${i18nPrefix}.btn.addNewLine`) }}</el-button>
              </div>
            </div>
          </template>
          <template #userMenu="{ item }">
            <SettingContentEditor
              class="user-menu-setting"
              v-model="data[key].userMenu"
              :setting="item.setting"
              :isDisabled="!isActive"
            />
          </template>
          <template #personalHomeMenuList>
            <PersonalCustomMenuList v-model="data[key].menuList" :isDisabled="!isActive" :dataKey="key" />
          </template>
        </SettingContentEditor>
      </div>
    </div>
    <div class="footer-btn-group adapt-wrapper">
      <el-button class="footer-btn save-btn blue-btn" @click="handleSave">{{ $t('common.btn.save') }}</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { CUSTOM_LANDING_PAGE_TYPE, DEVICE_PAGE_NUM_MAP, CUSTOM_SETTING_CONTENT_TYPE } from '@/constant/company'
import { FILE_TYPE } from '@/components/job/editor/uploader.vue'
import SettingContentEditor from './components/settingContentEditor.vue'
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'
import PersonalCustomMenuList from './components/personalCustomMenuList.vue'

const LANGUAGE_TYPE = {
  ZH: 'zh-cn',
  EN: 'en'
}

export default {
  components: {
    PersonalCustomMenuList,
    SettingContentEditor,
    draggable
  },
  data () {
    return {
      vid: 0,
      FILE_TYPE,
      LANGUAGE_TYPE,
      DEVICE_PAGE_NUM_MAP,
      CUSTOM_LANDING_PAGE_TYPE,
      CUSTOM_SETTING_CONTENT_TYPE,
      activePageNum: null,
      activeDeviceNum: null,
      i18nPrefix: 'admin.company.customCompanyTheme',
      customSetting: null,
      previewCustomSetting: null,
      showMobilePreviewDialog: false,
      customStyle: null,
      isActive: true,
      data: {
        headerSetting: {},
        footerSetting: {},
        commonSetting: {},
        personalHomePCSetting: {},
        personalHomeMobileSetting: {},
        loginSetting: {},
        companyDetailSetting: {}
      }
    }
  },
  computed: {
    setting () {
      return {
        commonSetting: {
          title: this.$t(`${this.i18nPrefix}.label.commonSetting`),
          items: {
            customColor: {
              type: CUSTOM_SETTING_CONTENT_TYPE.COLOR,
              label: this.$t(`${this.i18nPrefix}.label.customColor`)
            },
            customFont: {
              label: this.$t(`${this.i18nPrefix}.label.customFont`),
              type: CUSTOM_SETTING_CONTENT_TYPE.FONT,
              defaultValue: {
                fontFamilyList: [
                  {
                    key: new Date().getTime(),
                    name: '',
                    fileList: [],
                    active: false
                  },
                  {
                    key: 'PingFang SC',
                    name: 'PingFang SC',
                    fileList: [],
                    active: true,
                    isDefault: true
                  },
                  {
                    key: 'Hiragino Sans GB',
                    name: 'Hiragino Sans GB',
                    fileList: [],
                    active: true,
                    isDefault: true
                  },
                  {
                    key: 'Microsoft YaHei',
                    name: 'Microsoft YaHei',
                    fileList: [],
                    active: true,
                    isDefault: true
                  },
                  {
                    key: '微软雅黑',
                    name: '微软雅黑',
                    fileList: [],
                    active: true,
                    isDefault: true
                  },
                  {
                    key: 'Arial',
                    name: 'Arial',
                    fileList: [],
                    active: true,
                    isDefault: true
                  },
                  {
                    key: 'sans-serif',
                    name: 'sans-serif',
                    fileList: [],
                    active: true,
                    isDefault: true
                  }
                ]
              }
            },
            faviconImage: {
              label: this.$t(`${this.i18nPrefix}.label.faviconImage`),
              type: CUSTOM_SETTING_CONTENT_TYPE.IMAGE,
              defaultValue: null
            }
          }
        },
        headerSetting: {
          title: this.$t(`${this.i18nPrefix}.label.headerSetting`),
          items: {
            showCompanyLogo: {
              label: this.$t(`${this.i18nPrefix}.label.showCompanyLogo`),
              type: CUSTOM_SETTING_CONTENT_TYPE.SWITCH,
              defaultValue: true
            },
            logoImage: {
              label: this.$t(`${this.i18nPrefix}.label.logoImage`),
              type: CUSTOM_SETTING_CONTENT_TYPE.IMAGE,
              hidden: !this.data.headerSetting.showCompanyLogo,
              defaultValue: {
                url: this.$DjangoBaseUrl(this.customSetting?.company.logo)
              }
            },
            logoPosition: {
              label: this.$t(`${this.i18nPrefix}.label.logoPosition`),
              type: CUSTOM_SETTING_CONTENT_TYPE.POSITION,
              hidden: !this.data.headerSetting.showCompanyLogo,
              options: [
                {
                  key: 'left',
                  label: this.$t(`${this.i18nPrefix}.label.left`)
                },
                {
                  key: 'center',
                  label: this.$t(`${this.i18nPrefix}.label.center`)
                }
              ],
              defaultValue: 'left'
            },
            showCompanyName: {
              label: this.$t(`${this.i18nPrefix}.label.showCompanyName`),
              type: 'switch',
              defaultValue: true
            },
            logoWidth: {
              label: this.$t(`${this.i18nPrefix}.label.logoWidth`),
              type: CUSTOM_SETTING_CONTENT_TYPE.TEXT,
              hidden: !this.data.headerSetting.showCompanyLogo,
              defaultValue: '80',
              unit: 'px'
            },
            fixedHeader: {
              label: this.$t(`${this.i18nPrefix}.label.fixedHeader`),
              type: CUSTOM_SETTING_CONTENT_TYPE.SWITCH,
              defaultValue: false
            },
            headerHeight: {
              label: this.$t(`${this.i18nPrefix}.label.height`),
              type: CUSTOM_SETTING_CONTENT_TYPE.TEXT,
              defaultValue: '124',
              unit: 'px'
            },
            headerBackgroundColor: {
              label: this.$t(`${this.i18nPrefix}.label.backgroundColor`),
              type: CUSTOM_SETTING_CONTENT_TYPE.COLOR,
              defaultValue: '#ffffff'
            },
            headerFontColor: {
              label: this.$t(`${this.i18nPrefix}.label.fontColor`),
              type: CUSTOM_SETTING_CONTENT_TYPE.COLOR,
              defaultValue: '#606266'
            },
            phoneIcon: {
              label: this.$t(`${this.i18nPrefix}.label.phoneIcon`),
              type: CUSTOM_SETTING_CONTENT_TYPE.SWITCH,
              defaultValue: true
            },
            userMenu: {
              label: this.$t(`${this.i18nPrefix}.label.userMenu`),
              slotName: 'userMenu',
              setting: {
                backgroundColor: {
                  label: this.$t(`${this.i18nPrefix}.label.userMenuBackgroundColor`),
                  type: CUSTOM_SETTING_CONTENT_TYPE.COLOR
                },
                fontColor: {
                  label: this.$t(`${this.i18nPrefix}.label.userMenuFontColor`),
                  type: CUSTOM_SETTING_CONTENT_TYPE.COLOR
                }
              },
              defaultValue: {
                backgroundColor: '#ffffff',
                fontColor: null
              }
            }
          }
        },
        footerSetting: {
          title: this.$t(`${this.i18nPrefix}.label.footerSetting`),
          items: {
            footerHeight: {
              label: this.$t(`${this.i18nPrefix}.label.height`),
              type: CUSTOM_SETTING_CONTENT_TYPE.TEXT,
              unit: 'px'
            },
            footerBackgroundColor: {
              label: this.$t(`${this.i18nPrefix}.label.backgroundColor`),
              type: CUSTOM_SETTING_CONTENT_TYPE.COLOR
            },
            footerFontColor: {
              label: this.$t(`${this.i18nPrefix}.label.fontColor`),
              type: CUSTOM_SETTING_CONTENT_TYPE.COLOR,
              defaultValue: '#909399'
            },
            footerContent: {
              label: this.$t(`${this.i18nPrefix}.label.content`),
              slotName: 'footerContent',
              defaultValue: []
            }
          }
        },
        personalHomePCSetting: {
          title: this.$t(`${this.i18nPrefix}.label.personalHomePCSetting`),
          items: {
            menuList: {
              label: this.$t(`${this.i18nPrefix}.label.customMenuList`),
              slotName: 'personalHomeMenuList',
              defaultValue: [
                {
                  nameI18nKey: 'personal.menu.group.referrals',
                  key: 'referrals',
                  isDefault: true,
                  isActive: true,
                  onlyEmployee: false,
                  children: [
                    {
                      labelI18nKey: 'personal.menu.leads',
                      link: '/recruiting/personal/referral/leads',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: 'personal.menu.dashboard',
                      link: '/recruiting/personal/referral/dashboard',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: 'personal.menu.rewards',
                      link: '/recruiting/personal/referral/rewards',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: 'personal.menu.leaderBoard',
                      link: '/recruiting/personal/referral/leader-board',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: true,
                      disableChange: true
                    },
                    {
                      labelI18nKey: 'personal.menu.referralProgram',
                      link: '/recruiting/personal/referral/program',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    }
                  ]
                },
                {
                  nameI18nKey: 'personal.menu.group.functions',
                  key: 'functions',
                  isDefault: true,
                  isActive: true,
                  children: [
                    {
                      labelI18nKey: `${this.i18nPrefix}.label.bindOrChangeMobile`,
                      link: '/recruiting/personal/functions/change-email/',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: `${this.i18nPrefix}.label.bindOrChangeEmail`,
                      link: '/recruiting/personal/functions/change-mobile/',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: 'personal.menu.changePassword',
                      link: '/recruiting/personal/functions/change-password/',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    }
                  ]
                }
              ]
            }
          }
        },
        personalHomeMobileSetting: {
          title: this.$t(`${this.i18nPrefix}.label.personalHomeMobileSetting`),
          items: {
            menuList: {
              label: this.$t(`${this.i18nPrefix}.label.customMenuList`),
              slotName: 'personalHomeMenuList',
              defaultValue: [
                {
                  nameI18nKey: 'personal.menu.leaded',
                  key: 'referrals',
                  isDefault: true,
                  isActive: true,
                  onlyEmployee: false,
                  children: [
                    {
                      labelI18nKey: 'personal.menu.leads',
                      link: '/recruiting/personal/referral/leads',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: 'personal.menu.dashboard',
                      link: '/recruiting/personal/referral/dashboard',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: 'personal.menu.rewards',
                      link: '/recruiting/personal/referral/rewards',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: false
                    },
                    {
                      labelI18nKey: 'personal.menu.leaderBoard',
                      link: '/recruiting/personal/referral/leader-board',
                      isDefault: true,
                      isActive: true,
                      onlyEmployee: true,
                      disableChange: true
                    },
                    {
                      labelI18nKey: 'personal.menu.referralProgram',
                      link: '/recruiting/personal/referral/program',
                      isDefault: true,
                      isActive: false,
                      onlyEmployee: false
                    }
                  ]
                }
              ]
            }
          }
        },
        loginSetting: {
          title: this.$t(`${this.i18nPrefix}.label.loginSetting`),
          items: {
            backgroundColor: {
              label: this.$t(`${this.i18nPrefix}.label.pageBackgroundColor`),
              type: CUSTOM_SETTING_CONTENT_TYPE.COLOR
            },
            showContainerLogo: {
              label: this.$t(`${this.i18nPrefix}.label.showContainerLogo`),
              type: CUSTOM_SETTING_CONTENT_TYPE.SWITCH,
              defaultValue: true
            },
            followCustomColor: {
              label: this.$t(`${this.i18nPrefix}.label.followCustomColor`),
              type: CUSTOM_SETTING_CONTENT_TYPE.SWITCH,
              defaultValue: false
            }
          }
        },
        companyDetailSetting: {
          title: this.$t(`${this.i18nPrefix}.label.companyDetailSetting`),
          items: {
            menuList: {
              label: this.$t(`${this.i18nPrefix}.label.customMenuList`),
              type: CUSTOM_SETTING_CONTENT_TYPE.LIST,
              supportEnglish: true,
              defaultValue: [],
              defaultList: [
                this.$t(`${this.i18nPrefix}.label.homePage`),
                this.$t(`${this.i18nPrefix}.label.infoPage`),
                this.$t(`${this.i18nPrefix}.label.jobListPage`)
              ]
            },
            languagePosition: {
              label: this.$t(`${this.i18nPrefix}.label.languagePosition`),
              type: CUSTOM_SETTING_CONTENT_TYPE.POSITION,
              defaultValue: 'right'
            }
          }
        }
      }
    },
    tabList () {
      const i18nPrefix = this.i18nPrefix

      const list = [
        {
          pageNum: this.CUSTOM_LANDING_PAGE_TYPE.COMPANY_THEME_PC,
          label: this.$t(`${i18nPrefix}.label.candidateEndpoint`)
        }
      ]
      return list
    },
    activeLanguage () {
      return this.$route.query.language
    },
    routePageNum () {
      return this.$route.query.page_num
    }
  },
  created () {
    this.data = this.wrappedData({})
    this.initPage()
  },
  mounted () {

  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapActions('company', ['getCustomLandingPageInfo', 'updateCustomLandingPageInfo']),
    handleContentChange (e, value, valueIndex) {
      if (!e.removed || value[valueIndex].length > 0) {
        return
      }
      value.splice(valueIndex, 1)
    },
    handleDeleteContent (contentList, contentIndex, value, valueIndex) {
      if (!this.isActive) {
        return
      }
      if (contentList.length === 1) {
        value.splice(valueIndex, 1)
      } else {
        contentList.splice(contentIndex, 1)
      }
    },
    handleAddContent (contentList) {
      if (!this.isActive) {
        return
      }
      contentList.push({
        label: null,
        link: null
      })
    },
    handleAddNewContentList (data, key) {
      data.push([{
        label: null,
        link: null
      }])
    },
    wrappedData (data) {
      if (_.isEmpty(data)) {
        data = {}
      }
      _.forEach(this.setting, (settingList, settingKey) => {
        if (!data[settingKey]) {
          this.$set(data, settingKey, {})
        }
        _.forEach(settingList.items, (item, key) => {
          if (!data[settingKey][key] && !_.isBoolean(data[settingKey][key])) {
            this.$set(data[settingKey], key, item.defaultValue)
          }
        })
      })
      const personalHomePCMenuList = data.personalHomePCSetting.menuList
      const personalHomeMobileMenuList = data.personalHomeMobileSetting.menuList
      _.forEach([personalHomePCMenuList, personalHomeMobileMenuList], menuList => {
        _.forEach(menuList, (menuGroup, menuGroupIndex) => {
          menuGroup._vid = menuGroupIndex
          _.forEach(menuGroup.children, (menu, menuIndex) => {
            menu._vid = menuIndex
          })
        })
      })
      return data
    },
    initPage (initQuery) {
      let query = initQuery
      if (!initQuery) {
        const pageNum = this.routePageNum || CUSTOM_LANDING_PAGE_TYPE.COMPANY_THEME_PC
        const language = this.activeLanguage || LANGUAGE_TYPE.ZH
        query = {
          page_num: pageNum,
          language
        }
      }

      this.getPageInfo(query)
      this.updateQuery(query)
    },
    updateQuery (query) {
      this.activePageNum = DEVICE_PAGE_NUM_MAP[query.page_num]?.pc
      this.activeDeviceNum = query.page_num
      const needUpdate = !_.isEqual(query, this.$route.query)
      if (!needUpdate) {
        return
      }
      this.$router.push({ query })
    },
    async getPageInfo (query) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getCustomLandingPageInfo({
          pageNum: query.page_num,
          params: { language: query.language }
        })
        if (!resp) {
          return
        }
        this.customSetting = resp
        const items = this.customSetting.company_webpage_setting.items
        if (this.customSetting.company_webpage_setting.is_saved) {
          this.isActive = this.customSetting.company_webpage_setting.is_activated
        } else {
          this.isActive = true
        }
        this.data = this.wrappedData(items)

        this.customStyle = {
          '--custom-color': resp.company.custom_color
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async handleSave () {
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.uploadImage()
        const data = this.formatData()
        const resp = await this.updateCustomLandingPageInfo({
          pageNum: this.routePageNum,
          data
        })
        if (resp) {
          this.$message.success(this.$t('common.message.saveSuccess'))
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleCancel () {
      this.$router.go(0)
    },
    async uploadImage () {
      const allPromiseList = []
      _.forEach(this.$refs.settingContentEditor, ref => {
        if (ref.uploadImage) {
          allPromiseList.push(ref.uploadImage())
        }
      })
      await Promise.all(allPromiseList)
    },
    formatData () {
      const companyLogo = this.data.headerSetting.logoImage
      if (!companyLogo) {
        this.data.headerSetting.logoImage = {
          url: this.$DjangoBaseUrl(this.customSetting.company.logo)
        }
      }
      const companyWebPageSetting = this.customSetting.company_webpage_setting
      const data = {
        ...this.customSetting,
        language: this.activeLanguage,
        company_webpage_setting: {
          ...companyWebPageSetting,
          pc_branding_banner: this.customSetting.pcBrandingBanner,
          items: this.data,
          is_activated: this.isActive,
          video_navigation_list: _.filter(this.customSetting.videoNavigationList?.video_list, item => { return item.url })
        }
      }
      return data
    },
    changeLanguage (language) {
      const query = {
        ...this.$route.query,
        language
      }
      this.initPage(query)
    },
    changeDevice (deviceNum) {
      this.activeDeviceNum = deviceNum
      this.handlePageTabClick(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-company-theme-page {
  background: #fff;
  min-height: 100%;
  border-radius: 4px;
  margin-top: 15px;

  .header {
    display: flex;
    align-items: center;

    .page-title {
      font-size: 20px;
      color: #303133;
      font-weight: 500;
      margin-right: 28px;
    }
  }

  .tab-container {
    display: flex;

    .page-tab {
      flex: 1;
    }
  }

  .device-and-language-container {
    width: 680px;
    margin: 15px auto 0;
    font-size: 14px;
    display: flex;

    .language,
    .device {
      display: flex;
      line-height: 1;

      &.language {
        margin-left: auto;
      }

      .language-item,
      .device-item {
        cursor: pointer;

        &:last-child {
          margin-left: 12px;
          padding-left: 12px;
          border-left: 1px solid #ddd;
        }

        &.active {
          color: #0096cc;
        }
      }
    }
  }

  .setting-container {
    .setting-item {
      .title {
        display: flex;
        font-size: 18px;
        line-height: 24px;
        color: #303133;
        font-weight: 500;
        margin: 20px 0;

        .label {
          width: 20%;
          margin-right: 20px;
        }
      }

      .user-menu-setting {
        flex: 1;
      }

      .list-setting {
        width: auto;

        .item {
          margin-bottom: 10px;

          .container-wrapper {
            display: flex;
            align-items: center;
          }

          .el-divider {
            margin: 6px 0;
          }

          .content {
            display: flex;
            align-items: center;
            margin-right: 10px;

            .label {
              flex-shrink: 0;
              margin-right: 6px;
            }

            .link-input {
              width: 360px;
            }
          }

          .drag-btn {
            margin-right: 10px;
            cursor: pointer;

            &.is-disabled {
              cursor: not-allowed;
            }
          }

          .btn-group {

            .delete-btn {
              margin-right: 10px;
              color: red;
              cursor: pointer;

              &.is-disabled {
                cursor: not-allowed;
                color: rgba($color: red, $alpha: 0.7)
              }
            }

            .add-btn {
              color: #0096cc;
              cursor: pointer;

              &.is-disabled {
                cursor: not-allowed;
                color: rgba($color: #0096cc, $alpha: 0.7)
              }
            }
          }
        }

        .add-new-line-btn {
        }
      }
    }
  }

  .footer-btn-group {
    margin-top: 60px;
    text-align: right;

    .footer-btn {
      padding: 5px 25px;
      line-height: normal;

      &.cancel-btn {
        margin-right: auto;
      }
    }
  }
}
</style>
